/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgentQueueRouteRouteImport } from './routes/agent-queue/route'
import { Route as AgentPerformanceIndexRouteImport } from './routes/agent-performance/index'
import { Route as AgentPlaygroundIndexRouteImport } from './routes/agent-playground/index'
import { Route as AgentQueueIndexRouteImport } from './routes/agent-queue/index'
import { Route as AgentsIndexRouteImport } from './routes/agents/index'
import { Route as AiFunnelIndexRouteImport } from './routes/ai-funnel/index'
import { Route as AiPerformanceIndexRouteImport } from './routes/ai-performance/index'
import { Route as BookingLinkLogsIndexRouteImport } from './routes/booking-link-logs/index'
import { Route as CarDealerMatchIndexRouteImport } from './routes/car-dealer-match/index'
import { Route as DeadLeadsIndexRouteImport } from './routes/dead-leads/index'
import { Route as DealerAnalyticsIndexRouteImport } from './routes/dealer-analytics/index'
import { Route as DealerDeliveryIndexRouteImport } from './routes/dealer-delivery/index'
import { Route as DealerPerformanceIndexRouteImport } from './routes/dealer-performance/index'
import { Route as DealerTasksIndexRouteImport } from './routes/dealer-tasks/index'
import { Route as DecoyManagementIndexRouteImport } from './routes/decoy-management/index'
import { Route as E2eUserIdRouteRouteImport } from './routes/e2e/$userId/route'
import { Route as EvalTestingIndexRouteImport } from './routes/eval-testing/index'
import { Route as InspectionRerunIndexRouteImport } from './routes/inspection-rerun/index'
import { Route as InspectorIndexRouteImport } from './routes/inspector/index'
import { Route as LeadMonitorIndexRouteImport } from './routes/lead-monitor/index'
import { Route as NewCarCoverageIndexRouteImport } from './routes/new-car-coverage/index'
import { Route as PersonaManagementIndexRouteImport } from './routes/persona-management/index'
import { Route as PersonaManagementPicIdRouteRouteImport } from './routes/persona-management/$picId/route'
import { Route as PicLabelIndexRouteImport } from './routes/pic-label/index'
import { Route as PicPersonasIndexRouteImport } from './routes/pic-personas/index'
import { Route as SchedulerIndexRouteImport } from './routes/scheduler/index'
import { Route as StageOutcomeCanaryIndexRouteImport } from './routes/stage-outcome-canary/index'
import { Route as WatcherIndexRouteImport } from './routes/watcher/index'
import { Route as WinChatAnalyticsIndexRouteImport } from './routes/win-chat-analytics/index'
import { Route as WorkflowManagementIndexRouteImport } from './routes/workflow-management/index'
import { Route as WorkspaceIndexRouteImport } from './routes/workspace/index'
import { Route as AgentQueueOverviewIndexRouteImport } from './routes/agent-queue/overview/index'
import { Route as AgentsFollowupsIndexRouteImport } from './routes/agents/followups/index'
import { Route as AgentsManagerIndexRouteImport } from './routes/agents/manager/index'
import { Route as AgentsMemoryApprovalsIndexRouteImport } from './routes/agents/memory-approvals/index'
import { Route as AgentsTasksIndexRouteImport } from './routes/agents/tasks/index'
import { Route as AgentsTasksPicIdRouteImport } from './routes/agents/tasks/$picId'
import { Route as DealerAnalyticsAcquireIndexRouteImport } from './routes/dealer-analytics/acquire/index'
import { Route as DealerAnalyticsAcquiredIndexRouteImport } from './routes/dealer-analytics/acquired/index'
import { Route as DealerAnalyticsCandidatesIndexRouteImport } from './routes/dealer-analytics/candidates/index'
import { Route as DealerAnalyticsMissedIndexRouteImport } from './routes/dealer-analytics/missed/index'
import { Route as DealerAnalyticsNewDealerIndexRouteImport } from './routes/dealer-analytics/new-dealer/index'
import { Route as DealerAnalyticsPicFollowupIndexRouteImport } from './routes/dealer-analytics/pic-followup/index'
import { Route as E2eUserIdIndexRouteImport } from './routes/e2e/$userId/index'
import { Route as E2eUserIdDeadLeadsRouteImport } from './routes/e2e/$userId/dead-leads'
import { Route as PersonaManagementPicIdIndexRouteImport } from './routes/persona-management/$picId/index'
import { Route as PicLabelAnalyticsIndexRouteImport } from './routes/pic-label/analytics/index'
import { Route as E2eUserIdAiPerformanceIndexRouteImport } from './routes/e2e/$userId/ai-performance/index'
import { Route as E2eUserIdCrmBiIndexRouteImport } from './routes/e2e/$userId/crm-bi/index'
import { Route as E2eUserIdCxQcIndexRouteImport } from './routes/e2e/$userId/cx-qc/index'
import { Route as E2eUserIdDealersIndexRouteImport } from './routes/e2e/$userId/dealers/index'
import { Route as E2eUserIdFunnelIndexRouteImport } from './routes/e2e/$userId/funnel/index'
import { Route as E2eUserIdTasksIndexRouteImport } from './routes/e2e/$userId/tasks/index'
import { Route as PersonaManagementPicIdRunsCarIdRouteImport } from './routes/persona-management/$picId/runs/$carId'
import { Route as WatcherPicIdCarIdIndexRouteImport } from './routes/watcher/$picId/$carId/index'
import { Route as E2eUserIdLeadLeadIdIndexRouteImport } from './routes/e2e/$userId/lead/$leadId/index'
import { Route as E2eUserIdTasksViewIndexRouteImport } from './routes/e2e/$userId/tasks/$view/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentQueueRouteRoute = AgentQueueRouteRouteImport.update({
  id: '/agent-queue',
  path: '/agent-queue',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentPerformanceIndexRoute = AgentPerformanceIndexRouteImport.update({
  id: '/agent-performance/',
  path: '/agent-performance/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentPlaygroundIndexRoute = AgentPlaygroundIndexRouteImport.update({
  id: '/agent-playground/',
  path: '/agent-playground/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentQueueIndexRoute = AgentQueueIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentQueueRouteRoute,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => rootRouteImport,
} as any)
const AiFunnelIndexRoute = AiFunnelIndexRouteImport.update({
  id: '/ai-funnel/',
  path: '/ai-funnel/',
  getParentRoute: () => rootRouteImport,
} as any)
const AiPerformanceIndexRoute = AiPerformanceIndexRouteImport.update({
  id: '/ai-performance/',
  path: '/ai-performance/',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingLinkLogsIndexRoute = BookingLinkLogsIndexRouteImport.update({
  id: '/booking-link-logs/',
  path: '/booking-link-logs/',
  getParentRoute: () => rootRouteImport,
} as any)
const CarDealerMatchIndexRoute = CarDealerMatchIndexRouteImport.update({
  id: '/car-dealer-match/',
  path: '/car-dealer-match/',
  getParentRoute: () => rootRouteImport,
} as any)
const DeadLeadsIndexRoute = DeadLeadsIndexRouteImport.update({
  id: '/dead-leads/',
  path: '/dead-leads/',
  getParentRoute: () => rootRouteImport,
} as any)
const DealerAnalyticsIndexRoute = DealerAnalyticsIndexRouteImport.update({
  id: '/dealer-analytics/',
  path: '/dealer-analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const DealerDeliveryIndexRoute = DealerDeliveryIndexRouteImport.update({
  id: '/dealer-delivery/',
  path: '/dealer-delivery/',
  getParentRoute: () => rootRouteImport,
} as any)
const DealerPerformanceIndexRoute = DealerPerformanceIndexRouteImport.update({
  id: '/dealer-performance/',
  path: '/dealer-performance/',
  getParentRoute: () => rootRouteImport,
} as any)
const DealerTasksIndexRoute = DealerTasksIndexRouteImport.update({
  id: '/dealer-tasks/',
  path: '/dealer-tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const DecoyManagementIndexRoute = DecoyManagementIndexRouteImport.update({
  id: '/decoy-management/',
  path: '/decoy-management/',
  getParentRoute: () => rootRouteImport,
} as any)
const E2eUserIdRouteRoute = E2eUserIdRouteRouteImport.update({
  id: '/e2e/$userId',
  path: '/e2e/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const EvalTestingIndexRoute = EvalTestingIndexRouteImport.update({
  id: '/eval-testing/',
  path: '/eval-testing/',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectionRerunIndexRoute = InspectionRerunIndexRouteImport.update({
  id: '/inspection-rerun/',
  path: '/inspection-rerun/',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectorIndexRoute = InspectorIndexRouteImport.update({
  id: '/inspector/',
  path: '/inspector/',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadMonitorIndexRoute = LeadMonitorIndexRouteImport.update({
  id: '/lead-monitor/',
  path: '/lead-monitor/',
  getParentRoute: () => rootRouteImport,
} as any)
const NewCarCoverageIndexRoute = NewCarCoverageIndexRouteImport.update({
  id: '/new-car-coverage/',
  path: '/new-car-coverage/',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonaManagementIndexRoute = PersonaManagementIndexRouteImport.update({
  id: '/persona-management/',
  path: '/persona-management/',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonaManagementPicIdRouteRoute =
  PersonaManagementPicIdRouteRouteImport.update({
    id: '/persona-management/$picId',
    path: '/persona-management/$picId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PicLabelIndexRoute = PicLabelIndexRouteImport.update({
  id: '/pic-label/',
  path: '/pic-label/',
  getParentRoute: () => rootRouteImport,
} as any)
const PicPersonasIndexRoute = PicPersonasIndexRouteImport.update({
  id: '/pic-personas/',
  path: '/pic-personas/',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulerIndexRoute = SchedulerIndexRouteImport.update({
  id: '/scheduler/',
  path: '/scheduler/',
  getParentRoute: () => rootRouteImport,
} as any)
const StageOutcomeCanaryIndexRoute = StageOutcomeCanaryIndexRouteImport.update({
  id: '/stage-outcome-canary/',
  path: '/stage-outcome-canary/',
  getParentRoute: () => rootRouteImport,
} as any)
const WatcherIndexRoute = WatcherIndexRouteImport.update({
  id: '/watcher/',
  path: '/watcher/',
  getParentRoute: () => rootRouteImport,
} as any)
const WinChatAnalyticsIndexRoute = WinChatAnalyticsIndexRouteImport.update({
  id: '/win-chat-analytics/',
  path: '/win-chat-analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowManagementIndexRoute = WorkflowManagementIndexRouteImport.update({
  id: '/workflow-management/',
  path: '/workflow-management/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceIndexRoute = WorkspaceIndexRouteImport.update({
  id: '/workspace/',
  path: '/workspace/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentQueueOverviewIndexRoute = AgentQueueOverviewIndexRouteImport.update({
  id: '/overview/',
  path: '/overview/',
  getParentRoute: () => AgentQueueRouteRoute,
} as any)
const AgentsFollowupsIndexRoute = AgentsFollowupsIndexRouteImport.update({
  id: '/agents/followups/',
  path: '/agents/followups/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsManagerIndexRoute = AgentsManagerIndexRouteImport.update({
  id: '/agents/manager/',
  path: '/agents/manager/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsMemoryApprovalsIndexRoute =
  AgentsMemoryApprovalsIndexRouteImport.update({
    id: '/agents/memory-approvals/',
    path: '/agents/memory-approvals/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgentsTasksIndexRoute = AgentsTasksIndexRouteImport.update({
  id: '/agents/tasks/',
  path: '/agents/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsTasksPicIdRoute = AgentsTasksPicIdRouteImport.update({
  id: '/agents/tasks/$picId',
  path: '/agents/tasks/$picId',
  getParentRoute: () => rootRouteImport,
} as any)
const DealerAnalyticsAcquireIndexRoute =
  DealerAnalyticsAcquireIndexRouteImport.update({
    id: '/dealer-analytics/acquire/',
    path: '/dealer-analytics/acquire/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DealerAnalyticsAcquiredIndexRoute =
  DealerAnalyticsAcquiredIndexRouteImport.update({
    id: '/dealer-analytics/acquired/',
    path: '/dealer-analytics/acquired/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DealerAnalyticsCandidatesIndexRoute =
  DealerAnalyticsCandidatesIndexRouteImport.update({
    id: '/dealer-analytics/candidates/',
    path: '/dealer-analytics/candidates/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DealerAnalyticsMissedIndexRoute =
  DealerAnalyticsMissedIndexRouteImport.update({
    id: '/dealer-analytics/missed/',
    path: '/dealer-analytics/missed/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DealerAnalyticsNewDealerIndexRoute =
  DealerAnalyticsNewDealerIndexRouteImport.update({
    id: '/dealer-analytics/new-dealer/',
    path: '/dealer-analytics/new-dealer/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DealerAnalyticsPicFollowupIndexRoute =
  DealerAnalyticsPicFollowupIndexRouteImport.update({
    id: '/dealer-analytics/pic-followup/',
    path: '/dealer-analytics/pic-followup/',
    getParentRoute: () => rootRouteImport,
  } as any)
const E2eUserIdIndexRoute = E2eUserIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => E2eUserIdRouteRoute,
} as any)
const E2eUserIdDeadLeadsRoute = E2eUserIdDeadLeadsRouteImport.update({
  id: '/dead-leads',
  path: '/dead-leads',
  getParentRoute: () => E2eUserIdRouteRoute,
} as any)
const PersonaManagementPicIdIndexRoute =
  PersonaManagementPicIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PersonaManagementPicIdRouteRoute,
  } as any)
const PicLabelAnalyticsIndexRoute = PicLabelAnalyticsIndexRouteImport.update({
  id: '/pic-label/analytics/',
  path: '/pic-label/analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const E2eUserIdAiPerformanceIndexRoute =
  E2eUserIdAiPerformanceIndexRouteImport.update({
    id: '/ai-performance/',
    path: '/ai-performance/',
    getParentRoute: () => E2eUserIdRouteRoute,
  } as any)
const E2eUserIdCrmBiIndexRoute = E2eUserIdCrmBiIndexRouteImport.update({
  id: '/crm-bi/',
  path: '/crm-bi/',
  getParentRoute: () => E2eUserIdRouteRoute,
} as any)
const E2eUserIdCxQcIndexRoute = E2eUserIdCxQcIndexRouteImport.update({
  id: '/cx-qc/',
  path: '/cx-qc/',
  getParentRoute: () => E2eUserIdRouteRoute,
} as any)
const E2eUserIdDealersIndexRoute = E2eUserIdDealersIndexRouteImport.update({
  id: '/dealers/',
  path: '/dealers/',
  getParentRoute: () => E2eUserIdRouteRoute,
} as any)
const E2eUserIdFunnelIndexRoute = E2eUserIdFunnelIndexRouteImport.update({
  id: '/funnel/',
  path: '/funnel/',
  getParentRoute: () => E2eUserIdRouteRoute,
} as any)
const E2eUserIdTasksIndexRoute = E2eUserIdTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => E2eUserIdRouteRoute,
} as any)
const PersonaManagementPicIdRunsCarIdRoute =
  PersonaManagementPicIdRunsCarIdRouteImport.update({
    id: '/runs/$carId',
    path: '/runs/$carId',
    getParentRoute: () => PersonaManagementPicIdRouteRoute,
  } as any)
const WatcherPicIdCarIdIndexRoute = WatcherPicIdCarIdIndexRouteImport.update({
  id: '/watcher/$picId/$carId/',
  path: '/watcher/$picId/$carId/',
  getParentRoute: () => rootRouteImport,
} as any)
const E2eUserIdLeadLeadIdIndexRoute =
  E2eUserIdLeadLeadIdIndexRouteImport.update({
    id: '/lead/$leadId/',
    path: '/lead/$leadId/',
    getParentRoute: () => E2eUserIdRouteRoute,
  } as any)
const E2eUserIdTasksViewIndexRoute = E2eUserIdTasksViewIndexRouteImport.update({
  id: '/tasks/$view/',
  path: '/tasks/$view/',
  getParentRoute: () => E2eUserIdRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agent-queue': typeof AgentQueueRouteRouteWithChildren
  '/e2e/$userId': typeof E2eUserIdRouteRouteWithChildren
  '/persona-management/$picId': typeof PersonaManagementPicIdRouteRouteWithChildren
  '/agent-performance/': typeof AgentPerformanceIndexRoute
  '/agent-playground/': typeof AgentPlaygroundIndexRoute
  '/agent-queue/': typeof AgentQueueIndexRoute
  '/agents/': typeof AgentsIndexRoute
  '/ai-funnel/': typeof AiFunnelIndexRoute
  '/ai-performance/': typeof AiPerformanceIndexRoute
  '/booking-link-logs/': typeof BookingLinkLogsIndexRoute
  '/car-dealer-match/': typeof CarDealerMatchIndexRoute
  '/dead-leads/': typeof DeadLeadsIndexRoute
  '/dealer-analytics/': typeof DealerAnalyticsIndexRoute
  '/dealer-delivery/': typeof DealerDeliveryIndexRoute
  '/dealer-performance/': typeof DealerPerformanceIndexRoute
  '/dealer-tasks/': typeof DealerTasksIndexRoute
  '/decoy-management/': typeof DecoyManagementIndexRoute
  '/eval-testing/': typeof EvalTestingIndexRoute
  '/inspection-rerun/': typeof InspectionRerunIndexRoute
  '/inspector/': typeof InspectorIndexRoute
  '/lead-monitor/': typeof LeadMonitorIndexRoute
  '/new-car-coverage/': typeof NewCarCoverageIndexRoute
  '/persona-management/': typeof PersonaManagementIndexRoute
  '/pic-label/': typeof PicLabelIndexRoute
  '/pic-personas/': typeof PicPersonasIndexRoute
  '/scheduler/': typeof SchedulerIndexRoute
  '/stage-outcome-canary/': typeof StageOutcomeCanaryIndexRoute
  '/watcher/': typeof WatcherIndexRoute
  '/win-chat-analytics/': typeof WinChatAnalyticsIndexRoute
  '/workflow-management/': typeof WorkflowManagementIndexRoute
  '/workspace/': typeof WorkspaceIndexRoute
  '/agents/tasks/$picId': typeof AgentsTasksPicIdRoute
  '/e2e/$userId/dead-leads': typeof E2eUserIdDeadLeadsRoute
  '/agent-queue/overview/': typeof AgentQueueOverviewIndexRoute
  '/agents/followups/': typeof AgentsFollowupsIndexRoute
  '/agents/manager/': typeof AgentsManagerIndexRoute
  '/agents/memory-approvals/': typeof AgentsMemoryApprovalsIndexRoute
  '/agents/tasks/': typeof AgentsTasksIndexRoute
  '/dealer-analytics/acquire/': typeof DealerAnalyticsAcquireIndexRoute
  '/dealer-analytics/acquired/': typeof DealerAnalyticsAcquiredIndexRoute
  '/dealer-analytics/candidates/': typeof DealerAnalyticsCandidatesIndexRoute
  '/dealer-analytics/missed/': typeof DealerAnalyticsMissedIndexRoute
  '/dealer-analytics/new-dealer/': typeof DealerAnalyticsNewDealerIndexRoute
  '/dealer-analytics/pic-followup/': typeof DealerAnalyticsPicFollowupIndexRoute
  '/e2e/$userId/': typeof E2eUserIdIndexRoute
  '/persona-management/$picId/': typeof PersonaManagementPicIdIndexRoute
  '/pic-label/analytics/': typeof PicLabelAnalyticsIndexRoute
  '/persona-management/$picId/runs/$carId': typeof PersonaManagementPicIdRunsCarIdRoute
  '/e2e/$userId/ai-performance/': typeof E2eUserIdAiPerformanceIndexRoute
  '/e2e/$userId/crm-bi/': typeof E2eUserIdCrmBiIndexRoute
  '/e2e/$userId/cx-qc/': typeof E2eUserIdCxQcIndexRoute
  '/e2e/$userId/dealers/': typeof E2eUserIdDealersIndexRoute
  '/e2e/$userId/funnel/': typeof E2eUserIdFunnelIndexRoute
  '/e2e/$userId/tasks/': typeof E2eUserIdTasksIndexRoute
  '/watcher/$picId/$carId/': typeof WatcherPicIdCarIdIndexRoute
  '/e2e/$userId/lead/$leadId/': typeof E2eUserIdLeadLeadIdIndexRoute
  '/e2e/$userId/tasks/$view/': typeof E2eUserIdTasksViewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agent-performance': typeof AgentPerformanceIndexRoute
  '/agent-playground': typeof AgentPlaygroundIndexRoute
  '/agent-queue': typeof AgentQueueIndexRoute
  '/agents': typeof AgentsIndexRoute
  '/ai-funnel': typeof AiFunnelIndexRoute
  '/ai-performance': typeof AiPerformanceIndexRoute
  '/booking-link-logs': typeof BookingLinkLogsIndexRoute
  '/car-dealer-match': typeof CarDealerMatchIndexRoute
  '/dead-leads': typeof DeadLeadsIndexRoute
  '/dealer-analytics': typeof DealerAnalyticsIndexRoute
  '/dealer-delivery': typeof DealerDeliveryIndexRoute
  '/dealer-performance': typeof DealerPerformanceIndexRoute
  '/dealer-tasks': typeof DealerTasksIndexRoute
  '/decoy-management': typeof DecoyManagementIndexRoute
  '/eval-testing': typeof EvalTestingIndexRoute
  '/inspection-rerun': typeof InspectionRerunIndexRoute
  '/inspector': typeof InspectorIndexRoute
  '/lead-monitor': typeof LeadMonitorIndexRoute
  '/new-car-coverage': typeof NewCarCoverageIndexRoute
  '/persona-management': typeof PersonaManagementIndexRoute
  '/pic-label': typeof PicLabelIndexRoute
  '/pic-personas': typeof PicPersonasIndexRoute
  '/scheduler': typeof SchedulerIndexRoute
  '/stage-outcome-canary': typeof StageOutcomeCanaryIndexRoute
  '/watcher': typeof WatcherIndexRoute
  '/win-chat-analytics': typeof WinChatAnalyticsIndexRoute
  '/workflow-management': typeof WorkflowManagementIndexRoute
  '/workspace': typeof WorkspaceIndexRoute
  '/agents/tasks/$picId': typeof AgentsTasksPicIdRoute
  '/e2e/$userId/dead-leads': typeof E2eUserIdDeadLeadsRoute
  '/agent-queue/overview': typeof AgentQueueOverviewIndexRoute
  '/agents/followups': typeof AgentsFollowupsIndexRoute
  '/agents/manager': typeof AgentsManagerIndexRoute
  '/agents/memory-approvals': typeof AgentsMemoryApprovalsIndexRoute
  '/agents/tasks': typeof AgentsTasksIndexRoute
  '/dealer-analytics/acquire': typeof DealerAnalyticsAcquireIndexRoute
  '/dealer-analytics/acquired': typeof DealerAnalyticsAcquiredIndexRoute
  '/dealer-analytics/candidates': typeof DealerAnalyticsCandidatesIndexRoute
  '/dealer-analytics/missed': typeof DealerAnalyticsMissedIndexRoute
  '/dealer-analytics/new-dealer': typeof DealerAnalyticsNewDealerIndexRoute
  '/dealer-analytics/pic-followup': typeof DealerAnalyticsPicFollowupIndexRoute
  '/e2e/$userId': typeof E2eUserIdIndexRoute
  '/persona-management/$picId': typeof PersonaManagementPicIdIndexRoute
  '/pic-label/analytics': typeof PicLabelAnalyticsIndexRoute
  '/persona-management/$picId/runs/$carId': typeof PersonaManagementPicIdRunsCarIdRoute
  '/e2e/$userId/ai-performance': typeof E2eUserIdAiPerformanceIndexRoute
  '/e2e/$userId/crm-bi': typeof E2eUserIdCrmBiIndexRoute
  '/e2e/$userId/cx-qc': typeof E2eUserIdCxQcIndexRoute
  '/e2e/$userId/dealers': typeof E2eUserIdDealersIndexRoute
  '/e2e/$userId/funnel': typeof E2eUserIdFunnelIndexRoute
  '/e2e/$userId/tasks': typeof E2eUserIdTasksIndexRoute
  '/watcher/$picId/$carId': typeof WatcherPicIdCarIdIndexRoute
  '/e2e/$userId/lead/$leadId': typeof E2eUserIdLeadLeadIdIndexRoute
  '/e2e/$userId/tasks/$view': typeof E2eUserIdTasksViewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/agent-queue': typeof AgentQueueRouteRouteWithChildren
  '/e2e/$userId': typeof E2eUserIdRouteRouteWithChildren
  '/persona-management/$picId': typeof PersonaManagementPicIdRouteRouteWithChildren
  '/agent-performance/': typeof AgentPerformanceIndexRoute
  '/agent-playground/': typeof AgentPlaygroundIndexRoute
  '/agent-queue/': typeof AgentQueueIndexRoute
  '/agents/': typeof AgentsIndexRoute
  '/ai-funnel/': typeof AiFunnelIndexRoute
  '/ai-performance/': typeof AiPerformanceIndexRoute
  '/booking-link-logs/': typeof BookingLinkLogsIndexRoute
  '/car-dealer-match/': typeof CarDealerMatchIndexRoute
  '/dead-leads/': typeof DeadLeadsIndexRoute
  '/dealer-analytics/': typeof DealerAnalyticsIndexRoute
  '/dealer-delivery/': typeof DealerDeliveryIndexRoute
  '/dealer-performance/': typeof DealerPerformanceIndexRoute
  '/dealer-tasks/': typeof DealerTasksIndexRoute
  '/decoy-management/': typeof DecoyManagementIndexRoute
  '/eval-testing/': typeof EvalTestingIndexRoute
  '/inspection-rerun/': typeof InspectionRerunIndexRoute
  '/inspector/': typeof InspectorIndexRoute
  '/lead-monitor/': typeof LeadMonitorIndexRoute
  '/new-car-coverage/': typeof NewCarCoverageIndexRoute
  '/persona-management/': typeof PersonaManagementIndexRoute
  '/pic-label/': typeof PicLabelIndexRoute
  '/pic-personas/': typeof PicPersonasIndexRoute
  '/scheduler/': typeof SchedulerIndexRoute
  '/stage-outcome-canary/': typeof StageOutcomeCanaryIndexRoute
  '/watcher/': typeof WatcherIndexRoute
  '/win-chat-analytics/': typeof WinChatAnalyticsIndexRoute
  '/workflow-management/': typeof WorkflowManagementIndexRoute
  '/workspace/': typeof WorkspaceIndexRoute
  '/agents/tasks/$picId': typeof AgentsTasksPicIdRoute
  '/e2e/$userId/dead-leads': typeof E2eUserIdDeadLeadsRoute
  '/agent-queue/overview/': typeof AgentQueueOverviewIndexRoute
  '/agents/followups/': typeof AgentsFollowupsIndexRoute
  '/agents/manager/': typeof AgentsManagerIndexRoute
  '/agents/memory-approvals/': typeof AgentsMemoryApprovalsIndexRoute
  '/agents/tasks/': typeof AgentsTasksIndexRoute
  '/dealer-analytics/acquire/': typeof DealerAnalyticsAcquireIndexRoute
  '/dealer-analytics/acquired/': typeof DealerAnalyticsAcquiredIndexRoute
  '/dealer-analytics/candidates/': typeof DealerAnalyticsCandidatesIndexRoute
  '/dealer-analytics/missed/': typeof DealerAnalyticsMissedIndexRoute
  '/dealer-analytics/new-dealer/': typeof DealerAnalyticsNewDealerIndexRoute
  '/dealer-analytics/pic-followup/': typeof DealerAnalyticsPicFollowupIndexRoute
  '/e2e/$userId/': typeof E2eUserIdIndexRoute
  '/persona-management/$picId/': typeof PersonaManagementPicIdIndexRoute
  '/pic-label/analytics/': typeof PicLabelAnalyticsIndexRoute
  '/persona-management/$picId/runs/$carId': typeof PersonaManagementPicIdRunsCarIdRoute
  '/e2e/$userId/ai-performance/': typeof E2eUserIdAiPerformanceIndexRoute
  '/e2e/$userId/crm-bi/': typeof E2eUserIdCrmBiIndexRoute
  '/e2e/$userId/cx-qc/': typeof E2eUserIdCxQcIndexRoute
  '/e2e/$userId/dealers/': typeof E2eUserIdDealersIndexRoute
  '/e2e/$userId/funnel/': typeof E2eUserIdFunnelIndexRoute
  '/e2e/$userId/tasks/': typeof E2eUserIdTasksIndexRoute
  '/watcher/$picId/$carId/': typeof WatcherPicIdCarIdIndexRoute
  '/e2e/$userId/lead/$leadId/': typeof E2eUserIdLeadLeadIdIndexRoute
  '/e2e/$userId/tasks/$view/': typeof E2eUserIdTasksViewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agent-queue'
    | '/e2e/$userId'
    | '/persona-management/$picId'
    | '/agent-performance/'
    | '/agent-playground/'
    | '/agent-queue/'
    | '/agents/'
    | '/ai-funnel/'
    | '/ai-performance/'
    | '/booking-link-logs/'
    | '/car-dealer-match/'
    | '/dead-leads/'
    | '/dealer-analytics/'
    | '/dealer-delivery/'
    | '/dealer-performance/'
    | '/dealer-tasks/'
    | '/decoy-management/'
    | '/eval-testing/'
    | '/inspection-rerun/'
    | '/inspector/'
    | '/lead-monitor/'
    | '/new-car-coverage/'
    | '/persona-management/'
    | '/pic-label/'
    | '/pic-personas/'
    | '/scheduler/'
    | '/stage-outcome-canary/'
    | '/watcher/'
    | '/win-chat-analytics/'
    | '/workflow-management/'
    | '/workspace/'
    | '/agents/tasks/$picId'
    | '/e2e/$userId/dead-leads'
    | '/agent-queue/overview/'
    | '/agents/followups/'
    | '/agents/manager/'
    | '/agents/memory-approvals/'
    | '/agents/tasks/'
    | '/dealer-analytics/acquire/'
    | '/dealer-analytics/acquired/'
    | '/dealer-analytics/candidates/'
    | '/dealer-analytics/missed/'
    | '/dealer-analytics/new-dealer/'
    | '/dealer-analytics/pic-followup/'
    | '/e2e/$userId/'
    | '/persona-management/$picId/'
    | '/pic-label/analytics/'
    | '/persona-management/$picId/runs/$carId'
    | '/e2e/$userId/ai-performance/'
    | '/e2e/$userId/crm-bi/'
    | '/e2e/$userId/cx-qc/'
    | '/e2e/$userId/dealers/'
    | '/e2e/$userId/funnel/'
    | '/e2e/$userId/tasks/'
    | '/watcher/$picId/$carId/'
    | '/e2e/$userId/lead/$leadId/'
    | '/e2e/$userId/tasks/$view/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agent-performance'
    | '/agent-playground'
    | '/agent-queue'
    | '/agents'
    | '/ai-funnel'
    | '/ai-performance'
    | '/booking-link-logs'
    | '/car-dealer-match'
    | '/dead-leads'
    | '/dealer-analytics'
    | '/dealer-delivery'
    | '/dealer-performance'
    | '/dealer-tasks'
    | '/decoy-management'
    | '/eval-testing'
    | '/inspection-rerun'
    | '/inspector'
    | '/lead-monitor'
    | '/new-car-coverage'
    | '/persona-management'
    | '/pic-label'
    | '/pic-personas'
    | '/scheduler'
    | '/stage-outcome-canary'
    | '/watcher'
    | '/win-chat-analytics'
    | '/workflow-management'
    | '/workspace'
    | '/agents/tasks/$picId'
    | '/e2e/$userId/dead-leads'
    | '/agent-queue/overview'
    | '/agents/followups'
    | '/agents/manager'
    | '/agents/memory-approvals'
    | '/agents/tasks'
    | '/dealer-analytics/acquire'
    | '/dealer-analytics/acquired'
    | '/dealer-analytics/candidates'
    | '/dealer-analytics/missed'
    | '/dealer-analytics/new-dealer'
    | '/dealer-analytics/pic-followup'
    | '/e2e/$userId'
    | '/persona-management/$picId'
    | '/pic-label/analytics'
    | '/persona-management/$picId/runs/$carId'
    | '/e2e/$userId/ai-performance'
    | '/e2e/$userId/crm-bi'
    | '/e2e/$userId/cx-qc'
    | '/e2e/$userId/dealers'
    | '/e2e/$userId/funnel'
    | '/e2e/$userId/tasks'
    | '/watcher/$picId/$carId'
    | '/e2e/$userId/lead/$leadId'
    | '/e2e/$userId/tasks/$view'
  id:
    | '__root__'
    | '/'
    | '/agent-queue'
    | '/e2e/$userId'
    | '/persona-management/$picId'
    | '/agent-performance/'
    | '/agent-playground/'
    | '/agent-queue/'
    | '/agents/'
    | '/ai-funnel/'
    | '/ai-performance/'
    | '/booking-link-logs/'
    | '/car-dealer-match/'
    | '/dead-leads/'
    | '/dealer-analytics/'
    | '/dealer-delivery/'
    | '/dealer-performance/'
    | '/dealer-tasks/'
    | '/decoy-management/'
    | '/eval-testing/'
    | '/inspection-rerun/'
    | '/inspector/'
    | '/lead-monitor/'
    | '/new-car-coverage/'
    | '/persona-management/'
    | '/pic-label/'
    | '/pic-personas/'
    | '/scheduler/'
    | '/stage-outcome-canary/'
    | '/watcher/'
    | '/win-chat-analytics/'
    | '/workflow-management/'
    | '/workspace/'
    | '/agents/tasks/$picId'
    | '/e2e/$userId/dead-leads'
    | '/agent-queue/overview/'
    | '/agents/followups/'
    | '/agents/manager/'
    | '/agents/memory-approvals/'
    | '/agents/tasks/'
    | '/dealer-analytics/acquire/'
    | '/dealer-analytics/acquired/'
    | '/dealer-analytics/candidates/'
    | '/dealer-analytics/missed/'
    | '/dealer-analytics/new-dealer/'
    | '/dealer-analytics/pic-followup/'
    | '/e2e/$userId/'
    | '/persona-management/$picId/'
    | '/pic-label/analytics/'
    | '/persona-management/$picId/runs/$carId'
    | '/e2e/$userId/ai-performance/'
    | '/e2e/$userId/crm-bi/'
    | '/e2e/$userId/cx-qc/'
    | '/e2e/$userId/dealers/'
    | '/e2e/$userId/funnel/'
    | '/e2e/$userId/tasks/'
    | '/watcher/$picId/$carId/'
    | '/e2e/$userId/lead/$leadId/'
    | '/e2e/$userId/tasks/$view/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AgentQueueRouteRoute: typeof AgentQueueRouteRouteWithChildren
  E2eUserIdRouteRoute: typeof E2eUserIdRouteRouteWithChildren
  PersonaManagementPicIdRouteRoute: typeof PersonaManagementPicIdRouteRouteWithChildren
  AgentPerformanceIndexRoute: typeof AgentPerformanceIndexRoute
  AgentPlaygroundIndexRoute: typeof AgentPlaygroundIndexRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
  AiFunnelIndexRoute: typeof AiFunnelIndexRoute
  AiPerformanceIndexRoute: typeof AiPerformanceIndexRoute
  BookingLinkLogsIndexRoute: typeof BookingLinkLogsIndexRoute
  CarDealerMatchIndexRoute: typeof CarDealerMatchIndexRoute
  DeadLeadsIndexRoute: typeof DeadLeadsIndexRoute
  DealerAnalyticsIndexRoute: typeof DealerAnalyticsIndexRoute
  DealerDeliveryIndexRoute: typeof DealerDeliveryIndexRoute
  DealerPerformanceIndexRoute: typeof DealerPerformanceIndexRoute
  DealerTasksIndexRoute: typeof DealerTasksIndexRoute
  DecoyManagementIndexRoute: typeof DecoyManagementIndexRoute
  EvalTestingIndexRoute: typeof EvalTestingIndexRoute
  InspectionRerunIndexRoute: typeof InspectionRerunIndexRoute
  InspectorIndexRoute: typeof InspectorIndexRoute
  LeadMonitorIndexRoute: typeof LeadMonitorIndexRoute
  NewCarCoverageIndexRoute: typeof NewCarCoverageIndexRoute
  PersonaManagementIndexRoute: typeof PersonaManagementIndexRoute
  PicLabelIndexRoute: typeof PicLabelIndexRoute
  PicPersonasIndexRoute: typeof PicPersonasIndexRoute
  SchedulerIndexRoute: typeof SchedulerIndexRoute
  StageOutcomeCanaryIndexRoute: typeof StageOutcomeCanaryIndexRoute
  WatcherIndexRoute: typeof WatcherIndexRoute
  WinChatAnalyticsIndexRoute: typeof WinChatAnalyticsIndexRoute
  WorkflowManagementIndexRoute: typeof WorkflowManagementIndexRoute
  WorkspaceIndexRoute: typeof WorkspaceIndexRoute
  AgentsTasksPicIdRoute: typeof AgentsTasksPicIdRoute
  AgentsFollowupsIndexRoute: typeof AgentsFollowupsIndexRoute
  AgentsManagerIndexRoute: typeof AgentsManagerIndexRoute
  AgentsMemoryApprovalsIndexRoute: typeof AgentsMemoryApprovalsIndexRoute
  AgentsTasksIndexRoute: typeof AgentsTasksIndexRoute
  DealerAnalyticsAcquireIndexRoute: typeof DealerAnalyticsAcquireIndexRoute
  DealerAnalyticsAcquiredIndexRoute: typeof DealerAnalyticsAcquiredIndexRoute
  DealerAnalyticsCandidatesIndexRoute: typeof DealerAnalyticsCandidatesIndexRoute
  DealerAnalyticsMissedIndexRoute: typeof DealerAnalyticsMissedIndexRoute
  DealerAnalyticsNewDealerIndexRoute: typeof DealerAnalyticsNewDealerIndexRoute
  DealerAnalyticsPicFollowupIndexRoute: typeof DealerAnalyticsPicFollowupIndexRoute
  PicLabelAnalyticsIndexRoute: typeof PicLabelAnalyticsIndexRoute
  WatcherPicIdCarIdIndexRoute: typeof WatcherPicIdCarIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-queue': {
      id: '/agent-queue'
      path: '/agent-queue'
      fullPath: '/agent-queue'
      preLoaderRoute: typeof AgentQueueRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-performance/': {
      id: '/agent-performance/'
      path: '/agent-performance'
      fullPath: '/agent-performance/'
      preLoaderRoute: typeof AgentPerformanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-playground/': {
      id: '/agent-playground/'
      path: '/agent-playground'
      fullPath: '/agent-playground/'
      preLoaderRoute: typeof AgentPlaygroundIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-queue/': {
      id: '/agent-queue/'
      path: '/'
      fullPath: '/agent-queue/'
      preLoaderRoute: typeof AgentQueueIndexRouteImport
      parentRoute: typeof AgentQueueRouteRoute
    }
    '/agents/': {
      id: '/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-funnel/': {
      id: '/ai-funnel/'
      path: '/ai-funnel'
      fullPath: '/ai-funnel/'
      preLoaderRoute: typeof AiFunnelIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-performance/': {
      id: '/ai-performance/'
      path: '/ai-performance'
      fullPath: '/ai-performance/'
      preLoaderRoute: typeof AiPerformanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking-link-logs/': {
      id: '/booking-link-logs/'
      path: '/booking-link-logs'
      fullPath: '/booking-link-logs/'
      preLoaderRoute: typeof BookingLinkLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/car-dealer-match/': {
      id: '/car-dealer-match/'
      path: '/car-dealer-match'
      fullPath: '/car-dealer-match/'
      preLoaderRoute: typeof CarDealerMatchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dead-leads/': {
      id: '/dead-leads/'
      path: '/dead-leads'
      fullPath: '/dead-leads/'
      preLoaderRoute: typeof DeadLeadsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dealer-analytics/': {
      id: '/dealer-analytics/'
      path: '/dealer-analytics'
      fullPath: '/dealer-analytics/'
      preLoaderRoute: typeof DealerAnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dealer-delivery/': {
      id: '/dealer-delivery/'
      path: '/dealer-delivery'
      fullPath: '/dealer-delivery/'
      preLoaderRoute: typeof DealerDeliveryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dealer-performance/': {
      id: '/dealer-performance/'
      path: '/dealer-performance'
      fullPath: '/dealer-performance/'
      preLoaderRoute: typeof DealerPerformanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dealer-tasks/': {
      id: '/dealer-tasks/'
      path: '/dealer-tasks'
      fullPath: '/dealer-tasks/'
      preLoaderRoute: typeof DealerTasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/decoy-management/': {
      id: '/decoy-management/'
      path: '/decoy-management'
      fullPath: '/decoy-management/'
      preLoaderRoute: typeof DecoyManagementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/e2e/$userId': {
      id: '/e2e/$userId'
      path: '/e2e/$userId'
      fullPath: '/e2e/$userId'
      preLoaderRoute: typeof E2eUserIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eval-testing/': {
      id: '/eval-testing/'
      path: '/eval-testing'
      fullPath: '/eval-testing/'
      preLoaderRoute: typeof EvalTestingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspection-rerun/': {
      id: '/inspection-rerun/'
      path: '/inspection-rerun'
      fullPath: '/inspection-rerun/'
      preLoaderRoute: typeof InspectionRerunIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspector/': {
      id: '/inspector/'
      path: '/inspector'
      fullPath: '/inspector/'
      preLoaderRoute: typeof InspectorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lead-monitor/': {
      id: '/lead-monitor/'
      path: '/lead-monitor'
      fullPath: '/lead-monitor/'
      preLoaderRoute: typeof LeadMonitorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new-car-coverage/': {
      id: '/new-car-coverage/'
      path: '/new-car-coverage'
      fullPath: '/new-car-coverage/'
      preLoaderRoute: typeof NewCarCoverageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/persona-management/': {
      id: '/persona-management/'
      path: '/persona-management'
      fullPath: '/persona-management/'
      preLoaderRoute: typeof PersonaManagementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/persona-management/$picId': {
      id: '/persona-management/$picId'
      path: '/persona-management/$picId'
      fullPath: '/persona-management/$picId'
      preLoaderRoute: typeof PersonaManagementPicIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pic-label/': {
      id: '/pic-label/'
      path: '/pic-label'
      fullPath: '/pic-label/'
      preLoaderRoute: typeof PicLabelIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pic-personas/': {
      id: '/pic-personas/'
      path: '/pic-personas'
      fullPath: '/pic-personas/'
      preLoaderRoute: typeof PicPersonasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduler/': {
      id: '/scheduler/'
      path: '/scheduler'
      fullPath: '/scheduler/'
      preLoaderRoute: typeof SchedulerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stage-outcome-canary/': {
      id: '/stage-outcome-canary/'
      path: '/stage-outcome-canary'
      fullPath: '/stage-outcome-canary/'
      preLoaderRoute: typeof StageOutcomeCanaryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/watcher/': {
      id: '/watcher/'
      path: '/watcher'
      fullPath: '/watcher/'
      preLoaderRoute: typeof WatcherIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/win-chat-analytics/': {
      id: '/win-chat-analytics/'
      path: '/win-chat-analytics'
      fullPath: '/win-chat-analytics/'
      preLoaderRoute: typeof WinChatAnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflow-management/': {
      id: '/workflow-management/'
      path: '/workflow-management'
      fullPath: '/workflow-management/'
      preLoaderRoute: typeof WorkflowManagementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/': {
      id: '/workspace/'
      path: '/workspace'
      fullPath: '/workspace/'
      preLoaderRoute: typeof WorkspaceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-queue/overview/': {
      id: '/agent-queue/overview/'
      path: '/overview'
      fullPath: '/agent-queue/overview/'
      preLoaderRoute: typeof AgentQueueOverviewIndexRouteImport
      parentRoute: typeof AgentQueueRouteRoute
    }
    '/agents/followups/': {
      id: '/agents/followups/'
      path: '/agents/followups'
      fullPath: '/agents/followups/'
      preLoaderRoute: typeof AgentsFollowupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/manager/': {
      id: '/agents/manager/'
      path: '/agents/manager'
      fullPath: '/agents/manager/'
      preLoaderRoute: typeof AgentsManagerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/memory-approvals/': {
      id: '/agents/memory-approvals/'
      path: '/agents/memory-approvals'
      fullPath: '/agents/memory-approvals/'
      preLoaderRoute: typeof AgentsMemoryApprovalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/tasks/': {
      id: '/agents/tasks/'
      path: '/agents/tasks'
      fullPath: '/agents/tasks/'
      preLoaderRoute: typeof AgentsTasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/tasks/$picId': {
      id: '/agents/tasks/$picId'
      path: '/agents/tasks/$picId'
      fullPath: '/agents/tasks/$picId'
      preLoaderRoute: typeof AgentsTasksPicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dealer-analytics/acquire/': {
      id: '/dealer-analytics/acquire/'
      path: '/dealer-analytics/acquire'
      fullPath: '/dealer-analytics/acquire/'
      preLoaderRoute: typeof DealerAnalyticsAcquireIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dealer-analytics/acquired/': {
      id: '/dealer-analytics/acquired/'
      path: '/dealer-analytics/acquired'
      fullPath: '/dealer-analytics/acquired/'
      preLoaderRoute: typeof DealerAnalyticsAcquiredIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dealer-analytics/candidates/': {
      id: '/dealer-analytics/candidates/'
      path: '/dealer-analytics/candidates'
      fullPath: '/dealer-analytics/candidates/'
      preLoaderRoute: typeof DealerAnalyticsCandidatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dealer-analytics/missed/': {
      id: '/dealer-analytics/missed/'
      path: '/dealer-analytics/missed'
      fullPath: '/dealer-analytics/missed/'
      preLoaderRoute: typeof DealerAnalyticsMissedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dealer-analytics/new-dealer/': {
      id: '/dealer-analytics/new-dealer/'
      path: '/dealer-analytics/new-dealer'
      fullPath: '/dealer-analytics/new-dealer/'
      preLoaderRoute: typeof DealerAnalyticsNewDealerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dealer-analytics/pic-followup/': {
      id: '/dealer-analytics/pic-followup/'
      path: '/dealer-analytics/pic-followup'
      fullPath: '/dealer-analytics/pic-followup/'
      preLoaderRoute: typeof DealerAnalyticsPicFollowupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/e2e/$userId/': {
      id: '/e2e/$userId/'
      path: '/'
      fullPath: '/e2e/$userId/'
      preLoaderRoute: typeof E2eUserIdIndexRouteImport
      parentRoute: typeof E2eUserIdRouteRoute
    }
    '/e2e/$userId/dead-leads': {
      id: '/e2e/$userId/dead-leads'
      path: '/dead-leads'
      fullPath: '/e2e/$userId/dead-leads'
      preLoaderRoute: typeof E2eUserIdDeadLeadsRouteImport
      parentRoute: typeof E2eUserIdRouteRoute
    }
    '/persona-management/$picId/': {
      id: '/persona-management/$picId/'
      path: '/'
      fullPath: '/persona-management/$picId/'
      preLoaderRoute: typeof PersonaManagementPicIdIndexRouteImport
      parentRoute: typeof PersonaManagementPicIdRouteRoute
    }
    '/pic-label/analytics/': {
      id: '/pic-label/analytics/'
      path: '/pic-label/analytics'
      fullPath: '/pic-label/analytics/'
      preLoaderRoute: typeof PicLabelAnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/e2e/$userId/ai-performance/': {
      id: '/e2e/$userId/ai-performance/'
      path: '/ai-performance'
      fullPath: '/e2e/$userId/ai-performance/'
      preLoaderRoute: typeof E2eUserIdAiPerformanceIndexRouteImport
      parentRoute: typeof E2eUserIdRouteRoute
    }
    '/e2e/$userId/crm-bi/': {
      id: '/e2e/$userId/crm-bi/'
      path: '/crm-bi'
      fullPath: '/e2e/$userId/crm-bi/'
      preLoaderRoute: typeof E2eUserIdCrmBiIndexRouteImport
      parentRoute: typeof E2eUserIdRouteRoute
    }
    '/e2e/$userId/cx-qc/': {
      id: '/e2e/$userId/cx-qc/'
      path: '/cx-qc'
      fullPath: '/e2e/$userId/cx-qc/'
      preLoaderRoute: typeof E2eUserIdCxQcIndexRouteImport
      parentRoute: typeof E2eUserIdRouteRoute
    }
    '/e2e/$userId/dealers/': {
      id: '/e2e/$userId/dealers/'
      path: '/dealers'
      fullPath: '/e2e/$userId/dealers/'
      preLoaderRoute: typeof E2eUserIdDealersIndexRouteImport
      parentRoute: typeof E2eUserIdRouteRoute
    }
    '/e2e/$userId/funnel/': {
      id: '/e2e/$userId/funnel/'
      path: '/funnel'
      fullPath: '/e2e/$userId/funnel/'
      preLoaderRoute: typeof E2eUserIdFunnelIndexRouteImport
      parentRoute: typeof E2eUserIdRouteRoute
    }
    '/e2e/$userId/tasks/': {
      id: '/e2e/$userId/tasks/'
      path: '/tasks'
      fullPath: '/e2e/$userId/tasks/'
      preLoaderRoute: typeof E2eUserIdTasksIndexRouteImport
      parentRoute: typeof E2eUserIdRouteRoute
    }
    '/persona-management/$picId/runs/$carId': {
      id: '/persona-management/$picId/runs/$carId'
      path: '/runs/$carId'
      fullPath: '/persona-management/$picId/runs/$carId'
      preLoaderRoute: typeof PersonaManagementPicIdRunsCarIdRouteImport
      parentRoute: typeof PersonaManagementPicIdRouteRoute
    }
    '/watcher/$picId/$carId/': {
      id: '/watcher/$picId/$carId/'
      path: '/watcher/$picId/$carId'
      fullPath: '/watcher/$picId/$carId/'
      preLoaderRoute: typeof WatcherPicIdCarIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/e2e/$userId/lead/$leadId/': {
      id: '/e2e/$userId/lead/$leadId/'
      path: '/lead/$leadId'
      fullPath: '/e2e/$userId/lead/$leadId/'
      preLoaderRoute: typeof E2eUserIdLeadLeadIdIndexRouteImport
      parentRoute: typeof E2eUserIdRouteRoute
    }
    '/e2e/$userId/tasks/$view/': {
      id: '/e2e/$userId/tasks/$view/'
      path: '/tasks/$view'
      fullPath: '/e2e/$userId/tasks/$view/'
      preLoaderRoute: typeof E2eUserIdTasksViewIndexRouteImport
      parentRoute: typeof E2eUserIdRouteRoute
    }
  }
}

interface AgentQueueRouteRouteChildren {
  AgentQueueIndexRoute: typeof AgentQueueIndexRoute
  AgentQueueOverviewIndexRoute: typeof AgentQueueOverviewIndexRoute
}

const AgentQueueRouteRouteChildren: AgentQueueRouteRouteChildren = {
  AgentQueueIndexRoute: AgentQueueIndexRoute,
  AgentQueueOverviewIndexRoute: AgentQueueOverviewIndexRoute,
}

const AgentQueueRouteRouteWithChildren = AgentQueueRouteRoute._addFileChildren(
  AgentQueueRouteRouteChildren,
)

interface E2eUserIdRouteRouteChildren {
  E2eUserIdDeadLeadsRoute: typeof E2eUserIdDeadLeadsRoute
  E2eUserIdIndexRoute: typeof E2eUserIdIndexRoute
  E2eUserIdAiPerformanceIndexRoute: typeof E2eUserIdAiPerformanceIndexRoute
  E2eUserIdCrmBiIndexRoute: typeof E2eUserIdCrmBiIndexRoute
  E2eUserIdCxQcIndexRoute: typeof E2eUserIdCxQcIndexRoute
  E2eUserIdDealersIndexRoute: typeof E2eUserIdDealersIndexRoute
  E2eUserIdFunnelIndexRoute: typeof E2eUserIdFunnelIndexRoute
  E2eUserIdTasksIndexRoute: typeof E2eUserIdTasksIndexRoute
  E2eUserIdLeadLeadIdIndexRoute: typeof E2eUserIdLeadLeadIdIndexRoute
  E2eUserIdTasksViewIndexRoute: typeof E2eUserIdTasksViewIndexRoute
}

const E2eUserIdRouteRouteChildren: E2eUserIdRouteRouteChildren = {
  E2eUserIdDeadLeadsRoute: E2eUserIdDeadLeadsRoute,
  E2eUserIdIndexRoute: E2eUserIdIndexRoute,
  E2eUserIdAiPerformanceIndexRoute: E2eUserIdAiPerformanceIndexRoute,
  E2eUserIdCrmBiIndexRoute: E2eUserIdCrmBiIndexRoute,
  E2eUserIdCxQcIndexRoute: E2eUserIdCxQcIndexRoute,
  E2eUserIdDealersIndexRoute: E2eUserIdDealersIndexRoute,
  E2eUserIdFunnelIndexRoute: E2eUserIdFunnelIndexRoute,
  E2eUserIdTasksIndexRoute: E2eUserIdTasksIndexRoute,
  E2eUserIdLeadLeadIdIndexRoute: E2eUserIdLeadLeadIdIndexRoute,
  E2eUserIdTasksViewIndexRoute: E2eUserIdTasksViewIndexRoute,
}

const E2eUserIdRouteRouteWithChildren = E2eUserIdRouteRoute._addFileChildren(
  E2eUserIdRouteRouteChildren,
)

interface PersonaManagementPicIdRouteRouteChildren {
  PersonaManagementPicIdIndexRoute: typeof PersonaManagementPicIdIndexRoute
  PersonaManagementPicIdRunsCarIdRoute: typeof PersonaManagementPicIdRunsCarIdRoute
}

const PersonaManagementPicIdRouteRouteChildren: PersonaManagementPicIdRouteRouteChildren =
  {
    PersonaManagementPicIdIndexRoute: PersonaManagementPicIdIndexRoute,
    PersonaManagementPicIdRunsCarIdRoute: PersonaManagementPicIdRunsCarIdRoute,
  }

const PersonaManagementPicIdRouteRouteWithChildren =
  PersonaManagementPicIdRouteRoute._addFileChildren(
    PersonaManagementPicIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AgentQueueRouteRoute: AgentQueueRouteRouteWithChildren,
  E2eUserIdRouteRoute: E2eUserIdRouteRouteWithChildren,
  PersonaManagementPicIdRouteRoute:
    PersonaManagementPicIdRouteRouteWithChildren,
  AgentPerformanceIndexRoute: AgentPerformanceIndexRoute,
  AgentPlaygroundIndexRoute: AgentPlaygroundIndexRoute,
  AgentsIndexRoute: AgentsIndexRoute,
  AiFunnelIndexRoute: AiFunnelIndexRoute,
  AiPerformanceIndexRoute: AiPerformanceIndexRoute,
  BookingLinkLogsIndexRoute: BookingLinkLogsIndexRoute,
  CarDealerMatchIndexRoute: CarDealerMatchIndexRoute,
  DeadLeadsIndexRoute: DeadLeadsIndexRoute,
  DealerAnalyticsIndexRoute: DealerAnalyticsIndexRoute,
  DealerDeliveryIndexRoute: DealerDeliveryIndexRoute,
  DealerPerformanceIndexRoute: DealerPerformanceIndexRoute,
  DealerTasksIndexRoute: DealerTasksIndexRoute,
  DecoyManagementIndexRoute: DecoyManagementIndexRoute,
  EvalTestingIndexRoute: EvalTestingIndexRoute,
  InspectionRerunIndexRoute: InspectionRerunIndexRoute,
  InspectorIndexRoute: InspectorIndexRoute,
  LeadMonitorIndexRoute: LeadMonitorIndexRoute,
  NewCarCoverageIndexRoute: NewCarCoverageIndexRoute,
  PersonaManagementIndexRoute: PersonaManagementIndexRoute,
  PicLabelIndexRoute: PicLabelIndexRoute,
  PicPersonasIndexRoute: PicPersonasIndexRoute,
  SchedulerIndexRoute: SchedulerIndexRoute,
  StageOutcomeCanaryIndexRoute: StageOutcomeCanaryIndexRoute,
  WatcherIndexRoute: WatcherIndexRoute,
  WinChatAnalyticsIndexRoute: WinChatAnalyticsIndexRoute,
  WorkflowManagementIndexRoute: WorkflowManagementIndexRoute,
  WorkspaceIndexRoute: WorkspaceIndexRoute,
  AgentsTasksPicIdRoute: AgentsTasksPicIdRoute,
  AgentsFollowupsIndexRoute: AgentsFollowupsIndexRoute,
  AgentsManagerIndexRoute: AgentsManagerIndexRoute,
  AgentsMemoryApprovalsIndexRoute: AgentsMemoryApprovalsIndexRoute,
  AgentsTasksIndexRoute: AgentsTasksIndexRoute,
  DealerAnalyticsAcquireIndexRoute: DealerAnalyticsAcquireIndexRoute,
  DealerAnalyticsAcquiredIndexRoute: DealerAnalyticsAcquiredIndexRoute,
  DealerAnalyticsCandidatesIndexRoute: DealerAnalyticsCandidatesIndexRoute,
  DealerAnalyticsMissedIndexRoute: DealerAnalyticsMissedIndexRoute,
  DealerAnalyticsNewDealerIndexRoute: DealerAnalyticsNewDealerIndexRoute,
  DealerAnalyticsPicFollowupIndexRoute: DealerAnalyticsPicFollowupIndexRoute,
  PicLabelAnalyticsIndexRoute: PicLabelAnalyticsIndexRoute,
  WatcherPicIdCarIdIndexRoute: WatcherPicIdCarIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
